import { injectable } from 'inversify'
import Debug from 'debug'
import { Module, VuexModule, Mutation, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { Notification } from './notification'
import { AddNotificationPayload, HideNotificationPayload, RemoveNotificationPayload,
         UpdateNotificationPayload, NotificationStore } from '@xlearn/async-toolbox'

const debug = Debug('notification-store-module')

@injectable()
@Module({
  namespaced: true,
  name: 'notification',
  store,
  dynamic: true
})
export class NotificationStoreModule extends VuexModule implements NotificationStore {

  private items: Notification[] = []

  @Mutation
  public add<T>(addPayload: AddNotificationPayload<T>) {
    debug('add', addPayload)

    const item = findById(this.items, addPayload.id)
    if (item) {
      item.phase = 'show',
      item.options = { ...addPayload.options }
      item.payload = addPayload.payload
      return
    }
    
    this.items.push({
      ...addPayload,
      phase: 'show'
    })

    debug('notifications after add', this.items)
  }

  @Mutation
  public hide({ id }: HideNotificationPayload) {
    debug('hide', id)
    
    const item = findById(this.items, id)
    if (item) {
      item.phase = 'hide'
    }
  }

  @Mutation
  public remove({ id }: RemoveNotificationPayload) {
    debug('remove', id)

    const index = this.items.findIndex(x => x.id === id)
    if (index >= 0) {
      this.items = this.items.filter((_, i) => i !== index)
      debug('notifications after remove', this.items)
    }
  }

  public update(payload: UpdateNotificationPayload<unknown>) {
    debug('update', payload)

    const item = findById(this.items, payload.id)
    if (item) {
      item.payload = payload
    }
  }

  get notifications() {
    return this.items
  }
}

function findById(notifications: Notification[], id: string) {
  const item = notifications.find(x => x.id === id)

  return item
}


export default getModule(NotificationStoreModule);
